import axios from "axios";
import store from "../..";
import router from "../../../router/router";

export default {
  state: {
    userFirstName: localStorage.getItem("firstName"),
    userData: [],
    userPassword: null,
    resMessage: [],
    savedChanges: {},
    message: "",
  },
  mutations: {
    updateFirstName(state) {
      state.userFirstName = localStorage.getItem("firstName");
    },
    getUserData(state, payload) {
      state.userData = payload;
    },
    changeCurrentPassword(state, payload) {
      state.userPassword = payload;
    },
    updateMessage(state, messages) {
      messages.forEach((message) => {
        state.resMessage.push(message);
      });
    },
    getMessage(state, payload) {
      state.message = payload;
    },
    clearResMessage(state) {
      state.resMessage = [];
    },
    clearMessage(state) {
      state.message = "";
    },
    updateSavedChanges(state, payload) {
      state.savedChanges = payload;
    },
  },
  getters: {
    getAllUserData(state) {
      return state.userData;
    },
    changeUserPassword(state) {
      return state.userPassword;
    },
    getMsg(state) {
      return state.resMessage;
    },
    getMessage(state) {
      return state.message;
    },
    getSavedChanges(state) {
      return state.savedChanges;
    },
  },
  actions: {
    async getUserData(context) {
      let token = localStorage.getItem("token");
      let country_code = localStorage.getItem("country_code")
      const res = await axios.get("https://publish.dkilo.com/api/me", {
        headers: { token: token, "Country-Code": country_code },
      });
      context.commit("getUserData", res.data);
    },
    async changePassword(context) {
      let token = localStorage.getItem("token");
      let country_code = localStorage.getItem("country_code")
      const apiUrl = "https://publish.dkilo.com/api/update_password";
      const response = await axios.post(
        apiUrl,
        {
          new_password: context.state.userPassword,
        },
        {
          headers: {
            token: token,
            "Country-Code": country_code
          },
        }
      );
      context.commit("updateMessage", response.data.message);
    },
    async saveChanges(context) {
      let token = localStorage.getItem("token");
      let country_code = localStorage.getItem("country_code")
      const formData = new FormData();
      formData.append("first_name", context.state.savedChanges.first_name);
      formData.append("last_name", context.state.savedChanges.last_name);
      formData.append("email", context.state.savedChanges.email);
      formData.append("mobile", context.state.savedChanges.mobile);
      formData.append(
        "profile_picture",
        context.state.savedChanges.previewImage
      );

      try {
        let api = "https://publish.dkilo.com/api/edit";
        const res = await axios.post(api, formData, {
          headers: {
            token: token,
            "Country-Code": country_code
          },
        });

        localStorage.setItem("firstName", res.data.publisher.first_name);
        store.commit("updataProfile_pic", res.data.profile_picture);
        store.commit("updateFirstName");
        context.commit("getMessage", res.data.message);
      } catch (error) {
        let errorValues = error.response.data;
        for (let i = 0; i < Object.values(errorValues).length; i++) {
          let errorValue = Object.values(errorValues)[i];
          for (let j = 0; j < Object.values(errorValue).length; j++) {
            var allErrors = errorValue[j];
            console.log(allErrors);
            context.commit("updateMessage", [allErrors]);
          }
        }
      }

    },
  },
};
